// extracted by mini-css-extract-plugin
export default {"fondo":"Localizar_fondo__7wky-","grupo":"Localizar_grupo__iQYPS","titulo":"Localizar_titulo__3-uAh","label":"Localizar_label__+DJr5","data":"Localizar_data__fgPos"};